<template>
  <div class="flex flex-column custom-justify relative full-height mmy2 light-grey-bg top-margin" :class="[{'white-bg-mobile' : isSubscriptionTDA}]">
    <div class="flex flex-column bottom-margin">
      <div class="flex flex-column col-12">
        <div v-if="!isCartRecap && !isSubscriptionTDA" class="flex col-12 caps py3 px4 border-bottom unit-bg">{{ offer.name }}</div>
        <div v-else-if="isSubscriptionTDA && subscriptionTitle" :class="['flex col-12 py3 body-padding-desktop white-bg border-bottom', {'sticky-top-mobile': headerSticky}]">
          <div class="flex flex-column col-10">
            <span class="caps bolder">{{ subscriptionTitle }}</span>
            <span v-if="subscriptionSubtitle" class="h6 mt1"> {{ subscriptionSubtitle }}</span>
          </div>
          <div class="flex col-2 items-center justify-center">
            <i v-if="!isTariffs" class="h2 icon icon-chevron-left pointer" @click="backNavigation()"></i>
          </div>
        </div>
        <router-view
          :scroll-to-top="scrollToTop"
          :total="total"
          :can-show-cgi-error="canShowCgiError"
          :can-show-cart-installments-error="canShowInstallmentsError"
          @updateCgi="(e) => cgi = e"
          @updateParceled="(e) => parceled = e"
          @discountAmountFee="changeAmountFee"
          @discountAmount="changeAmount"
          @discountMetric="selectMetric"
          @discountMotive="selectMotive"
          @subscriptionStart="selectDate"
          @setOptionHorse="setHorseOption"
          @selected-installments="setInstallmentOption"
        />
      </div>
    </div>
    <SubscriptionFooter v-if="isSubscriptionTDA" :confirm-function="confirm" :can-advance="canAdvance" />
    <NewTDAFooter v-else :confirm-function="confirm" :can-advance="canAdvance" :total="total" :total-with-campaign="totalWithCampaign" />
  </div>
</template>

<script>
import { format, parse } from 'date-fns';
import NewTDAFooter from '../components/footer/NewTDAFooter.vue';
import SubscriptionFooter from '../components/footer/SubscriptionFooter.vue';
import { generateImageUrl, computeFunnelType } from '@/utils/utils';
import { changeToPage, injectCurrentParticipant, initializeCartItem, computePromo } from '@/utils/logics';
import { generatePaymentSession, createParticipant, updateCustomer } from '@/utils/requests';
import { computeDataLayerWithoutRoute } from '@/utils/index';

export default {
  components: {
    NewTDAFooter,
    SubscriptionFooter
  },
  data () {
    return {
      user: this.$store.state.user,
      product: this.$store.state.product,
      offer: this.$store.state.offerInfo,
      cgi: false,
      canShowCgiError: false,
      parceled: false,
      selectedMetric: null,
      promoAmountFee: null,
      promoAmount: null,
      selectedtMotive: null,
      subscriptionStartDate: null,
      horseOwnerType: null,
      customInstallment: false,
      selectedInstallmentsPayment: null,
      canShowInstallmentsError: false
    };
  },
  computed: {
    isSubscriptionTDA () {
      return this.$store.state.subscriptionTDA;
    },
    isTariffs () {
      return this.$route.name === 'NewTDATariffsSubscription';
    },
    subscriptionAction () {
      return this.$store.state.subscriptionAction;
    },
    subscriptionTitle () {
      return this.$store.state.subscriptionHeader?.title;
    },
    subscriptionSubtitle () {
      return this.$store.state.subscriptionHeader?.subtitle;
    },
    headerSticky () {
      return this.$store.state.subscriptionHeader?.mobileSticky;
    },
    isCartRecap () {
      return this.$route.name === 'NewTDACartRecap';
    },
    canAdvance () {
      switch (this.$route.name) {
        case 'NewTDAParticipants':
          return !!this.currentParticipant;
        case 'NewTDASessions':
          return !!this.cartItem?.session;
        case 'NewTDATariffs':
        case 'NewTDATariffsSubscription': {
          if (!(this.tariffs && this.tariffs.length)) {
            return false;
          }
          // Check if partner tariff (Gymlib) is selected and requires validation
          const partnerTariff = this.tariffs.find(tariff => {
            const price = this.offer?.detail?.prices?.find(p => p.tariffCode === tariff.tariffCode);
            return price && price.isGymlibTariff === true;
          });
          if (partnerTariff) {
            // Partner tariff requires Gymlib code validation
            return partnerTariff.gymlibCodeValid === true && !!partnerTariff.gymlibCode;
          }
          return true;
        }
        case 'NewTDAParticipantSubscription':
        case 'NewTDACartRecapRecurring':
          return this.$store.state.formValid;
        default:
          return true;
      }
    },
    cartItem () {
      const { cartItem } = this.$store.state;
      return cartItem;
    },
    tariffs () {
      return this.cartItem && this.cartItem.tariffs && this.cartItem.tariffs.length ? this.cartItem.tariffs : [];
    },
    currentParticipant () {
      return this.$store.state.currentParticipant;
    },
    hasOptions () {
      return this.tariffs.some(tariff => tariff.availableOptions && tariff.availableOptions.length);
    },
    showParticipantStep () {
      return this.$store.state.showParticipantStep;
    },
    showSessionsStep () {
      return this.$store.state.showSessionsStep;
    },
    showTariffsStep () {
      return this.$store.state.showTariffsStep;
    },
    steps () {
      return this.$store.state.steps;
    },
    buyer () {
      return this.user.contacts.find(c => c.uuid === this.user.uuid);
    },
    participant () {
      const { cartItem } = this.$store.state;

      return cartItem ? cartItem.participants.find(
        p => p.uuid === this.user.uuid
      ) : {};
    },
    subscriptionParticipant () {
      return this.cartItem.participants[0] || {};
    },
    total () {
      let price = 0;

      this.tariffs.forEach(tariff => {
        if (!tariff.isGymlibTariff) {
          const promo = computePromo(tariff);
          if (promo.canShow) {
            price += promo.price * tariff.quantity;
          } else {
            price += tariff.price * tariff.quantity;
          }
        }

        (tariff.options || []).forEach(option => {
          const optPromo = computePromo(option);

          if (optPromo.canShow) {
            price += optPromo.price * option.quantity;
          } else {
            price += option.price.price * option.quantity;
          }
        });
      });
      return (price / 100).toFixed(2);
    },
    totalWithCampaign () {
      if (this.promoCampaign) {
        let price = 0;

        this.tariffs.forEach(tariff => {
          const discount = (1 - this.promoCampaign.discount) / 100;
          price += (tariff.price * discount) * tariff.quantity;

          (tariff.options || []).forEach(option => {
            price += option.price.price * option.quantity;
          });
        });
        return (price / 100).toFixed(2);
      }
      if (this.selectedMetric) {
        const price = parseFloat(this.total);
        const metric = this.selectedMetric;
        const amount = this.promoAmount ? parseFloat(this.promoAmount) : null;
        const amountFee = this.promoAmountFee ? parseFloat(this.promoAmountFee) : null;

        if ((amount || amountFee) && metric) {
          let value = price;
          switch (metric) {
            case 'euro': {
              let discountPrice = price;
              if (amountFee) discountPrice = parseFloat((discountPrice - amountFee).toFixed(2));
              if (amount) discountPrice = parseFloat((discountPrice - amount).toFixed(2));
              value = discountPrice;
              break;
            }
            case 'percentage': {
              value = parseFloat(((1 - (amount / 100)) * price).toFixed(2));
              break;
            }
            default:
          }
          return value.toString();
        }
      }
      return this.total;
    },
    visitedSteps () {
      return this.$store.state.visitedSteps;
    },
    promoCampaign () {
      return this.$store.state.promoCampaign;
    },
    isImpersonateMode () {
      return this.$store.getters.isImpersonateMode;
    },
    workspaceCart () {
      return (this.$store.state.cart?.items || []).find(item => item.workspace === this.$store.state.siteInfo.workspace);
    },
    cartInstallments () {
      return this.workspaceCart?.details[0]?.installments;
    }
  },
  watch: {
    cgi (newVal, _oldVal) {
      if (newVal) {
        this.canShowCgiError = false;
      }
    }
  },
  mounted () {
    const firstStep = this.steps[0];
    initializeCartItem(
      {
        participants: this.showParticipantStep || this.isSubscriptionTDA ? [] : [this.buyer],
        offer: this.offer,
        product: this.product,
        callback: () => this.changeToPage(firstStep.name)
      }
    );
  },
  methods: {
    generateImageUrl,
    changeToPage,
    backNavigation () {
      const customerForm = this.$store.state.showCustomerForm;
      const contactForm = this.$store.state.showEmergencyContactForm;

      if (customerForm || contactForm) {
        this.$store.commit('setShowCustomerForm', false);
        this.$store.commit('setShowEmergencyContactForm', false);
        this.$store.commit('setFormValid', false);
        this.$store.commit('setCartItem', { ...this.$store.state.cartItem, participants: [] });

        return;
      }

      this.$store.commit('setBackNavigation', true);
      switch (this.$route.name) {
        case 'NewTDAParticipantSubscription':
          this.$router.push({ name: 'NewTDATariffsSubscription' });
          break;
        case 'NewTDACartRecapRecurring':
          this.$router.push({ name: 'NewTDAParticipantSubscription' });
          break;

        default:
          break;
      }
      this.$store.commit('setBackNavigation', false);
    },
    async confirm () {
      switch (this.$route.meta.type) {
        case 'participant':
          await this.confirmParticipant();
          break;
        case 'tariffs':
          if (this.isSubscriptionTDA) {
            this.changeToPage('NewTDAParticipantSubscription');
          } else {
            await this.confirmTariff();
          }
          break;
        case 'participantSubscription':
          await this.confirmParticipantManagement();
          break;
        case 'sessions':
          await this.confirmSession();
          break;
        case 'recap':
          await this.confirmPayment();
          this.scrollToTop();
          break;
        default:
          break;
      }
    },
    async confirmParticipantManagement () {
      switch (this.subscriptionAction) {
        case 'createParticipant': {
          this.createParticipant();
          break;
        }

        case 'editParticipant': {
          this.editParticipant();
          break;
        }

        case 'createEmergencyContact': {
          this.createEmergencyContact();
          break;
        }

        case 'editEmergencyContact': {
          this.editEmergencyContact();
          break;
        }
        case 'recap': {
          this.$store.commit('setLoading', true);
          await injectCurrentParticipant({ ...this.subscriptionParticipant, options: this.tariffs[0].options, tariff: this.tariffs[0], quantity: 1 }, true);
          this.$store.commit('setLoading', false);
          break;
        }

        default:
          break;
      }
    },
    async confirmParticipant () {
      this.$store.commit('setLoading', true);
      this.$store.commit('setCartItem', { ...this.$store.state.cartItem, participants: [this.currentParticipant] });

      if (!this.showTariffsStep) {
        this.$store.commit('setCartItem', {
          ...this.cartItem,
          tariffs: [{ ...this.offer.detail.prices[0], quantity: 1 }]
        });
        const { currentParticipant } = this.$store.state;
        await injectCurrentParticipant({ ...currentParticipant, quantity: 1 }, true);
      } else {
        this.changeToPage('NewTDATariffs');
        this.$store.commit('setLoading', false);
      }
    },
    async confirmTariff () {
      this.$store.commit('setLoading', true);
      const { currentParticipant } = this.$store.state;
      const { options } = this.offer;
      currentParticipant.options = options;
      await injectCurrentParticipant({ ...currentParticipant, quantity: this.participant.quantity }, true);
      this.$store.commit('setLoading', false);
    },
    async confirmSession () {
      this.$store.commit('setLoading', true);
      await injectCurrentParticipant(null, true);
      this.$store.commit('setLoading', false);
    },
    async confirmPayment () {
      this.$store.commit('setLoading', true);
      this.handlePay();
    },
    async createParticipant () {
      this.$store.commit('setLoading', true);

      const response = await createParticipant({
        ...this.subscriptionParticipant,
        birthdate: format(parse(this.subscriptionParticipant.birth_date, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd'),
        email: this.user.email,
        user: this.user
      });

      this.$store.commit('setLoading', false);

      if (response && response.success && response.customer) {
        const createdCustomer = response.customer.contacts.filter(contact => !this.user.contacts.map(c => c.uuid).includes(contact.uuid));
        this.user.contacts.push({ ...createdCustomer[0] });
        this.$store.commit('setUser', this.user);

        this.$store.commit('setCartItem', { ...this.cartItem, participants: createdCustomer });
        this.$store.commit('setShowCustomerForm', false);
        this.$store.commit('setSubscriptionAction', 'createEmergencyContact');
        this.$store.commit('setShowEmergencyContactForm', true);
        return;
      }
      let errorMessage = '';
      switch (response.code) {
        case 'ERROR_1':
          this.$store.commit('setFormError', { error: 'Veuillez utiliser des informations de contact différentes.', showAdditionalError: true });
          break;
        case 'ERROR_2':
          errorMessage = 'Si ce produit est pour vous, vous n’avez pas besoin de créer un participant. Veuillez choisir votre compte dans la liste en cliquant sur “précédent”.';
          if (this.isSubscriptionTDA) {
            errorMessage = "Si cet abonnement est pour vous, vous n'avez pas besoin de créer un participant. Veuillez choisir votre compte dans la liste ci-dessus.";
          }
          this.$store.commit('setFormError', { error: errorMessage, showAdditionalError: false });
          break;
        default:
          this.$store.commit('setFormError', { error: 'Erreur inconnue. Veuillez contacter notre support.', showAdditionalError: true });
          break;
      }
    },
    async editParticipant () {
      this.$store.commit('setLoading', true);
      const response = await updateCustomer({ customer: this.subscriptionParticipant });
      this.$store.commit('setLoading', false);
      if (response && response.updateCustomer && response.updateCustomer.success && response.updateCustomer.customer) {
        const updatedCustomer = response.updateCustomer.customer;

        if (this.user.uuid === updatedCustomer.uuid) {
          this.user = updatedCustomer;
          this.$store.commit('setUser', updatedCustomer);
        } else {
          const participantIndex = this.user.contacts.findIndex(contact => contact.uuid === updatedCustomer.uuid);

          if (participantIndex !== -1) {
            this.user.contacts[participantIndex] = updatedCustomer;
            this.$store.commit('setUser', this.user);
          }
        }
        computeDataLayerWithoutRoute('selectParticipant');
        this.$store.commit('setCartItem', { ...this.cartItem, participants: [{ ...this.subscriptionParticipant, ...updatedCustomer }] });
        this.$store.commit('setShowCustomerForm', false);
        this.$store.commit('setSubscriptionAction', 'recap');
        return;
      }

      this.$store.commit('setFormError', { error: 'Erreur inconnue. Veuillez contacter notre support.', showAdditionalError: true });
    },
    async createEmergencyContact () {
      this.$store.commit('setLoading', true);
      const response = await updateCustomer({ customer: this.subscriptionParticipant });
      this.$store.commit('setLoading', false);

      if (response && response.updateCustomer && response.updateCustomer.success) {
        const contactIndex = this.user.contacts.findIndex(contact => contact.uuid === response.updateCustomer.customer.uuid);
        if (contactIndex !== -1) {
          this.user.contacts[contactIndex].emergency_contacts = response.updateCustomer.customer.emergency_contacts;
          this.$store.commit('setUser', this.user);
        }

        this.$store.commit('setLoading', true);
        await injectCurrentParticipant({ ...this.subscriptionParticipant, options: this.tariffs[0].options, tariff: this.tariffs[0], quantity: 1 }, true);
        this.$store.commit('setLoading', false);
        this.$store.commit('setShowEmergencyContactForm', false);
        return;
      }
      this.$store.commit('setFormError', { error: 'Erreur inconnue. Veuillez contacter notre support.', showAdditionalError: true });
    },
    async editEmergencyContact () {
      this.$store.commit('setLoading', true);
      const response = await updateCustomer({ customer: this.subscriptionParticipant });
      this.$store.commit('setLoading', false);

      if (response && response.updateCustomer && response.updateCustomer.success) {
        const contactIndex = this.user.contacts.findIndex(contact => contact.uuid === response.updateCustomer.customer.uuid);
        if (contactIndex !== -1) {
          this.user.contacts[contactIndex].emergency_contacts = response.updateCustomer.customer.emergency_contacts;
          this.$store.commit('setUser', this.user);
        }
        this.$store.commit('setLoading', true);
        await injectCurrentParticipant({ ...this.subscriptionParticipant, options: this.tariffs[0].options, tariff: this.tariffs[0], quantity: 1 }, true);
        this.$store.commit('setLoading', false);
        this.$store.commit('setShowEmergencyContactForm', false);
        return;
      }
      this.$store.commit('setFormError', { error: 'Erreur inconnue. Veuillez contacter notre support.', showAdditionalError: true });
    },
    async handlePay () {
      if (!this.cgi && !this.isImpersonateMode) {
        this.canShowCgiError = true;
        this.$store.commit('setLoading', false);
        return;
      }

      if (this.cartInstallments && !this.selectedInstallmentsPayment) {
        this.canShowInstallmentsError = true;
        this.$store.commit('setLoading', false);
        return;
      }

      window.dataLayer.push({
        checkoutStepName: 'prêt à payer',
        checkoutStepNumber: 8,
        event: 'ecommerceNEO',
        eventCommand: 'checkoutStep',
        checkoutStepActive: 'oui',
        tunnelType: computeFunnelType()
      });

      const args = {
        user: this.$store.state.user.uuid,
        workspace: this.$store.getters.workspace,
        parceled: this.parceled,
        promoAmount: this.promoAmount,
        promoAmountFee: this.promoAmountFee,
        promoMetric: this.selectedMetric,
        promoCode: this.promoCampaign ? this.promoCampaign.code : null,
        promoRecurring: this.$store.state.recurringPromo,
        promoMotive: this.selectedMotive,
        subscriptionStartDate: this.subscriptionStartDate,
        horseOwnerType: this.horseOwnerType,
        forceInstallments: this.customInstallment
      };
      await generatePaymentSession(args);
    },
    scrollToTop () {
      const elem = document.querySelector('#contentDiv');
      if (elem) {
        elem.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    selectMetric (value) {
      this.selectedMetric = value;
    },
    selectMotive (value) {
      this.selectedMotive = value;
    },
    changeAmount (value) {
      this.promoAmount = value;
    },
    changeAmountFee (value) {
      this.promoAmountFee = value;
    },
    selectDate (value) {
      this.subscriptionStartDate = value;
    },
    setHorseOption (value) {
      this.horseOwnerType = value.value;
    },
    setInstallmentOption (value) {
      this.selectedInstallmentsPayment = value;
      this.customInstallment = value === 'installment';
      this.canShowInstallmentsError = false;
    }
  }
};
</script>

<style lang="scss" scoped>

@media (max-width: 40em) {
  .mmy2{
    margin-top: 1rem;
  }
  .custom-justify {
    justify-content: space-between;
  }
}

@media (min-width: 40em) {
  .top-margin {
    padding-top: 2.5rem;
  }

  .bottom-margin {
    padding-bottom: 2.5rem;
  }
}
</style>
